import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigServiceProvider } from '../../../core/services/config-service/config-service';
import { StorageServiceProvider } from '../../../core/services/storage-service/storage-service';
import { Prize } from '../../interfaces/prize.interface';

@Injectable()
export class PrizesServiceProvider {
  constructor(public http: HttpClient, private configService: ConfigServiceProvider, private storageService: StorageServiceProvider) {}

  public load(): Promise<any> {
    return new Promise<void>((resolve, reject) => {
      Promise.all([
        this.http.get(this.configService.getUrl('prizes')).toPromise(),
        this.http.get(this.configService.getUrl('prizeClaims')).toPromise(),
      ])
        .then((response: any) => {
          let [prizes, prizeClaims] = response;
          Promise.all([this.storageService.setObject('prizes', prizes), this.savePrizeClaims(prizeClaims)])
            .then(() => resolve())
            .catch((err) => reject(err));
        })
        .catch((err) => reject(err));
    });
  }

  public getPrizes(): Promise<Prize[]> {
    return this.storageService.getObject('prizes');
  }

  public getPrizeClaims(): Promise<any> {
    return this.storageService.getObject('prizeClaims');
  }

  public getPrize(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.storageService
        .getObject('prizes')
        .then((prizes: Prize[]) => {
          const prize = prizes.find((prize) => prize.id === id);
          if (prize) resolve(prize);
          else reject('object_not_found');
        })
        .catch((err) => reject(err));
    });
  }

  public savePrizeClaims(prizeClaims) {
    this.storageService.setObject('prizeClaims', prizeClaims);
  }

  public savePrizes(prize: Prize) {
    this.storageService.getObject('prizes').then((prizes: Prize[]) => {
      const prizeIndex = prizes.findIndex((p) => p.id === prize.id);
      prizes[prizeIndex] = prize;
      this.storageService.setObject('prizes', prizes);
    });
  }

  public choosePrize(prizeId: string, prizeClaimId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(this.configService.getUrl('prizeClaims') + '/' + prizeClaimId + '/' + 'choose' + '/' + prizeId + '/prize')
        .toPromise()
        .then((response) => resolve(response))
        .catch((err) => reject(err));
    });
  }
}



// WEBPACK FOOTER //
// ./src/modules/prizes/services/prizes-service/prizes-service.ts